@use "../../styles/breakpoint.module.scss" as *;

.root {
    position: fixed;
    bottom: var(--spacer-24);
    left: 50%;
    width: var(--spacer-40);
    height: var(--spacer-40);
    padding: 4px;
    z-index: 999;
    border-radius: 50%;
    background: var(--light-beige);
    translate: -50% 0;
    animation: bounce 3.5s ease infinite;
    transition: opacity 0.2s;

    @media ($below-mobile) {
        --spacer-40: 32px;
    }
}

.clickable {
    composes: root;
    opacity: 1;
}

.hiddenClickable {
    composes: root;
    opacity: 0;
    user-select: none;
    pointer-events: none;
}

.svg {
    width: var(--spacer-32);
    height: var(--spacer-32);
    rotate: 90deg;
    translate: 0 2px;
    fill: var(--black);
}

@keyframes bounce {
    0% {
        transform: translateY(0);
    }

    5.55556% {
        transform: translateY(0);
    }

    11.11111% {
        transform: translateY(0);
    }

    22.22222% {
        transform: translateY(-15px);
    }

    27.77778% {
        transform: translateY(0);
    }

    33.33333% {
        transform: translateY(-15px);
    }

    44.44444% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(0);
    }
}
